
import API from "../../../services/api";
import { 
	ClientIDLoginParam, 
	ClientIDLoginRequest, 
	ClientIDLoginResponse 
} from "../types/clientId";

// static getUsers(): Promise<User[]> {
// 	return new Promise<User[]>((resolve, reject) => {
// 		API.get(`${ENDPOINT}/users`)
// 			.then((value: User[]) => {
// 				const formataatexmep = values.map()
// 				resolve(formataatexmep)
// 			}).catch((error) => {
// 				reject("oh no")
// 				reject(error)
// 			})
// 	})
// }

enum Endpoints {
	LoginClientId = "/user/client_id"
}

const login = ({
	clientId,
	secret
}: ClientIDLoginParam) => {
	return new Promise<ClientIDLoginResponse>(async (resolve, reject) => {
		API.post<ClientIDLoginResponse, ClientIDLoginRequest>({
			endpoint: Endpoints.LoginClientId,
			data: {
				client_id: clientId,
				secret
			}
		})
		.then(res => {
			resolve(res.promise.data);
		})
		.catch(err => {
			reject(err);
		})
	})
}

export default {
	login
};